import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import {
  PersonaHelpContent,
  HelpContent,
} from '@shared/constants/persona-help-text-constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  personaDisplayHelpContent,
  PersonaName,
} from '@entities/persona/persona.model';
import { CarouselComponent } from '@shared/components/carousel/carousel.component';

@Component({
    selector: 'nwx-persona-help-modal',
    templateUrl: './persona-help-modal.component.html',
    styleUrl: './persona-help-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PersonaHelpModalComponent {
  @Input() items: any;
  @Input() personaNameSelected: string | undefined;

  constructor(private modal: NgbActiveModal) {}

  closeModal(): void {
    this.modal.close();
  }

  onChoosePersona(name: string, event: Event): void {
    event.preventDefault();
    if (this.personaNameSelected !== name) {
      this.personaNameSelected = name;
    }
  }

  getPersonaHelpContent(): string {
    return personaDisplayHelpContent(this.personaNameSelected as PersonaName);
  }

  getHelpContentTypes(): { type: string; icon: string }[] {
    const types = PersonaHelpContent.map((item) => item.type);
    return [...new Set(types)].map((type) => {
      return { type: type, icon: this.getIconFromType(type) };
    });
  }

  getIconFromType(type: string) {
    switch (type) {
      case 'Property':
        return 'property.svg';
      case 'Auto':
        return 'city-car.svg';
      case 'More':
        return 'person-laptop.svg';
    }
    return '';
  }

  getHelpContent(type: string): HelpContent[] {
    return PersonaHelpContent.filter(
      (item) => item.enabled && item.type == type
    );
  }
}
